import React from "react";
import { PageNotFound } from "@sscs/ui";
import { FILESTREAM_ROUTE, LOGIN_ROUTE } from "Constants";
import { useIsAuthenticated } from "Hooks";
import PublicReportBanner from "../../components/PublicReportBanner/PublicReportBanner";

const SharedReportNotFound = (): React.JSX.Element => {
  const auth = useIsAuthenticated();

  return (
    <>
      <PublicReportBanner
        loginTo={
          auth.isAuthenticated ? `/${FILESTREAM_ROUTE}` : `/${LOGIN_ROUTE}`
        }
        exportedVersion={null}
      />
      <PageNotFound
        title="Report not found"
        byline="The report link you were trying to access is not available or has expired. Please contact the person who shared it with you."
      />
    </>
  );
};

export default SharedReportNotFound;
